export const adminItems = ["/auth/register", "/users", "/sla-metrics"];

export const validatedItems = [
  "/auth/profile",
  "/auth/register",
  "/auth/change-password",
];
